<script setup lang="ts">
import type { Component } from "vue";

withDefaults( defineProps<{
  as?: string | Component;
}>(), {
  as: "div",
} );
</script>

<template>
  <component
    :is="$attrs.onSubmit ? 'form' : as"
    class="card"
    v-bind="$attrs">
    <div class="card__content">
      <div
        v-if="$slots.header"
        class="card__header">
        <slot name="header" />
      </div>
      <div class="card__body">
        <slot />
      </div>
      <div
        v-if="$slots.footer"
        class="card__footer">
        <slot name="footer" />
      </div>
    </div>
  </component>
</template>

<style scoped lang="scss">
.card {
  height: 100%;
  width: 100%;
  border-radius: var(--card-border-radius, 0.5rem);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--card-background);
  }

  &__header {
    flex-shrink: 0;
    padding: var(--card-header-padding, 1rem);
    background-color: var(--card-header-background, inherit);
    box-sizing: border-box;
  }

  &__body {
    flex: 1;
    padding: var(--card-body-padding, 1rem);
    background-color: var(--card-body-background, inherit);
    box-sizing: border-box;
    overflow: auto;
  }

  &__footer {
    flex-shrink: 0;
    padding: var(--card-footer-padding, 1rem);
    background-color: var(--card-footer-background, inherit);
    box-sizing: border-box;
  }
}
</style>
